module.exports = __webpack_public_path__ + "img/instagram_color.2a4eb6ec.svg";